module.exports = __webpack_public_path__ + "img/logo-h2m.7f44fe94.png";